import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

axios.defaults.withCredentials = true;

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
}

axios.interceptors.request.use(
    config => {
        config.headers.Authorization = localStorage.getItem('token');
        return config;
    },
    error => Promise.reject(error)
)

axios.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401) {
            const isLoginRequest = originalRequest && originalRequest.url && originalRequest.url.endsWith('/login');
            const isRefreshRequest = originalRequest && originalRequest.url && originalRequest.url.endsWith('/refresh');

            if (isLoginRequest || isRefreshRequest) {
                if (isRefreshRequest) {
                    localStorage.removeItem('token');
                    window.location = '/';
                }
                return Promise.reject(error);
            }

            if (originalRequest._retry) {
                localStorage.removeItem('token');
                window.location = '/';
                return Promise.reject(error);
            }

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    originalRequest.headers.Authorization = token;
                    return axios(originalRequest);
                }).catch(err => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            return new Promise((resolve, reject) => {
                axios.post(`${API_URL}/refresh`, {})
                    .then(response => {
                        const newToken = response.data.token;
                        localStorage.setItem('token', newToken);
                        originalRequest.headers.Authorization = newToken;
                        processQueue(null, newToken);
                        resolve(axios(originalRequest));
                    })
                    .catch(err => {
                        processQueue(err, null);
                        localStorage.removeItem('token');
                        window.location = '/';
                        reject(err);
                    })
                    .finally(() => {
                        isRefreshing = false;
                    });
            });
        }

        return Promise.reject(error);
    });

export default axios;